/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiUserAvailabilityFromJSON, StreemApiUserAvailabilityToJSON, } from './';
export function StreemApiUpdateUserAvailabilityResponseFromJSON(json) {
    return StreemApiUpdateUserAvailabilityResponseFromJSONTyped(json, false);
}
export function StreemApiUpdateUserAvailabilityResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userAvailability': !exists(json, 'user_availability') ? undefined : StreemApiUserAvailabilityFromJSON(json['user_availability']),
    };
}
export function StreemApiUpdateUserAvailabilityResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'user_availability': StreemApiUserAvailabilityToJSON(value.userAvailability),
    };
}
//# sourceMappingURL=StreemApiUpdateUserAvailabilityResponse.js.map